<div class="course-generate">
  <div class="course-generate__content">
    <div class="course-generate__image-container">
      <img
        class="course-generate__image"
        src="/public/images/valvur.png"
        alt="Course generation"
      />
    </div>
    <div class="course-generate__text">
      {{ 'app.components.courseCreator.generate.uploading' | translate }}<span class="course-generate__dots">
        <span class="course-generate__dot">.</span>
        <span class="course-generate__dot">.</span>
        <span class="course-generate__dot">.</span>
      </span>
    </div>
  </div>
</div>

